export default __webpack_public_path__ + "static/media/play.e79215b3.svg";